<template>
  <div class="pc-container">
    <div v-for="(item,index) in data" :key="index">
      <component :is="item.type" :data="item"></component>
    </div>
    <div style="height: 50px"></div>
  </div>
</template>

<script>
import {projectData} from "@/data";
export default {
  name: 'ProjectView',
  data(){
    return {
      data:projectData
    }
  }
}
</script>
<style lang="scss" scoped></style>
